import Slider from "../Slider/Slider";
import LazyImage from "../common/LazyImage";
import pluses1 from "../../images/icons/pluses1.svg";
import pluses2 from "../../images/icons/pluses2.svg";
import pluses3 from "../../images/icons/pluses3.svg";
import pluses4 from "../../images/icons/pluses4.svg";
import mainImage from "../../images/home/about_main.jpg";

const Home = () => {
  return (
    <div className="home">
      <div className="head page-width_large">
        <Slider />
      </div>
      <div className="about page-width flex-column">
        <div className="advantages flex-row flex-center gap-grid">
          <div className="advantage-item first-item flex-column">
            <img src={pluses1} alt="IoT" />
            <h4>Инновации в каждом решении</h4>
            <p className="text-m">
              Оборудование, разработанное с применением новейших технологий,
              включая IoT и облачные вычисления
            </p>
          </div>
          <div className="advantage-item second-item flex-column">
            <img src={pluses2} alt="IoT" />
            <h4>Надёжное оборудование</h4>
            <p className="text-m">
              Гарантия 2 года, срок эксплуатации не менее 10 лет
            </p>
          </div>
          <div className="advantage-item flex-column">
            <img src={pluses3} alt="IoT" />
            <h4>Быстрая логистика</h4>
            <p className="text-m">
              Более 8000 единиц оборудования в наличии на складе в России
            </p>
          </div>
          <div className="advantage-item last-item flex-column">
            <img src={pluses4} alt="IoT" />
            <h4>Соответствие стандартам</h4>
            <p className="text-m">
              Вся продукция соответствует техническим регламентам РФ
              и требованиям сейсмостойкости
            </p>
          </div>
        </div>
        <div className="description flex-column gap-8x w-100">
          <h1>О компании</h1>
          <div className="main-info gap-8x w-100">
            <LazyImage
              src={mainImage}
              alt="main"
              className="main-image"
              maxWidth="774px"
              maxHeight="400px"
            />
            <div className="flex-column flex-center gap-4x">
              <p className="text-xl">
                <span className="text-xl text-accent-default">AQUASTRONG</span>{" "}
                — международный бренд с более чем 30-летним опытом разработки,
                производства и продажи современных насосных решений.
              </p>
              <p className="text-m">
                Наша продукция успешно применяется в системах водоснабжения,
                водоотведения, водоочистки и циркуляции — от частных домов
                до масштабных промышленных объектов. С 2022 года мы активно
                развивается на российском рынке и имеем представительсва на всей
                территоррии РФ.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="news">
        <div className="page-width"></div>
      </div>
      <div className="form">
        <div className="page-width"></div>
      </div>
    </div>
  );
};

export default Home;
